<div class="bea_search_container">
    <form [formGroup]="searchForm" (ngSubmit)="onSubmit(searchForm.value)" >
        <input formControlName="query" type="text" id="searchField" class="bea_search_textbox" />
        <button type="submit" class="bea_search_button">{{ 'nav.search' | translate }}</button>
    </form>
</div>

